import { jwtDecode } from 'jwt-decode';

import { storage } from 'src/utils/storage';

import type { Token } from 'src/features/auth/types';

const getLocalUserId = () => {
    const { access } = storage.getToken();
    if (access == null) return '';
    const { sub } = jwtDecode<Token>(access);
    return sub;
};

export { getLocalUserId };
